const useCleanSlugUrl = (slug = '') => {
  let cleanedSlug = slug.replace('/blog/', '').replace('/snippets/', '')
  if (cleanedSlug && cleanedSlug.at(-1) === '/') {
    cleanedSlug = cleanedSlug.slice(0, -1)
  }

  return cleanedSlug
}

export default useCleanSlugUrl
